// hooks/travelRequest/context.js

import { createContext, useContext, useReducer, useMemo } from 'react';
import { travelRequestReducer, initialState } from './reducer';

const TravelRequestContext = createContext();

export const TravelRequestProvider = ({ children }) => {
    const [state, dispatch] = useReducer(travelRequestReducer, initialState);

    const value = useMemo(() => [state, dispatch], [state]);

    return <TravelRequestContext.Provider value={value}>{children}</TravelRequestContext.Provider>;
};

export const useTravelRequestContext = () => {
    const context = useContext(TravelRequestContext);
    if (!context) {
        throw new Error('useTravelRequestContext must be used within a TravelRequestProvider');
    }
    return context;
};
